import VForm from "@/vuetify_custom/v-form";
import VModel from "@/vuetify_custom/v-modal_v1";
import { TEXT_FIELD } from "@/vuetify_custom/v-form/type_name";
import {
  sellSettlementConfirmApi,
  getFinReceiptBillStatementMatchSearchApi,
} from "../services";

const createParams = () => {
  return {
    id: null,
    fin_receipt_bill_id: null,
  };
};

export default {
  data() {
    return {
      dis: false,
      submitLoading: false,
      params: createParams(),
      billList: [],
    };
  },
  computed: {
    baseInfoFields() {
      const d = [(val) => !!val || "必选"];
      const arr = [
        {
          label: "收款单ID",
          key: "fin_receipt_bill_id",
          type: "autocompletes_async_v1",
          "item-value": "id",
          api: this.$util.api.fin_receipt_bill_statement_match_search,
          "item-text": "text_name",
          initList: this.billList,
          cols: 12,
          required: true,
          out_params: {
            flag: "settlement",
          },
          handle_data: ({ receipt_bills }) => {
            return receipt_bills.map((item) => ({
              ...item,
              text_name: `${item.uid}-${item.name}`,
            }));
          },
          change: (data, target) => {
            this.changeBill(target);
          },
          rules: d,
        },
      ];
      return arr.filter((item) => !item.hide);
    },
  },
  mounted() {},
  watch: {},
  methods: {
    open(id) {
      this.params.id = id;
      this.dis = true;
      this.params.fin_receipt_bill_id = null;
      this.billList = [];
    },
    submit() {
      if (
        !(
          this.$refs.base &&
          this.$refs.base.validate &&
          this.$refs.base.validate()
        )
      ) {
        return;
      }
      this.submitLoading = true;

      sellSettlementConfirmApi(this.params)
        .then(() => {
          this.dis = false;
          this.$emit("success");
          this.$Message.success("保存成功！");
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    close() {
      this.dis = false;
      this.$emit("close");
    },
    changeBill(target) {
      if (!target) {
        this.params.fin_receipt_bill_id = null;
        return;
      }
      this.params.fin_receipt_bill_id = target.id;
    },
  },
  render() {
    return (
      <VModel
        v-model={this.dis}
        persistent
        dynamic-height
        height-rate={0.7}
        title={"确认收款"}
        loading={this.submitLoading}
        on={{
          ok: this.submit,
          cancel: this.close,
        }}
      >
        <VForm ref="base" v-model={this.params} fields={this.baseInfoFields} />
      </VModel>
    );
  },
};
